import type { ReactNode } from 'react'
import { ChevronRight } from 'lucide-react'

interface DrillCardProps {
  label: string
  value?: string
  preview?: ReactNode
  icon?: ReactNode
  onClick: () => void
}

export function DrillCard({ label, value, preview, icon, onClick }: DrillCardProps) {
  return (
    <button
      onClick={onClick}
      className="w-full rounded-[14px] border border-border bg-background p-3 flex items-center gap-3 text-left active:scale-[0.98] transition-transform"
    >
      {icon && <div className="shrink-0 text-muted-foreground">{icon}</div>}
      {preview && <div className="shrink-0">{preview}</div>}
      <div className="flex-1 min-w-0">
        <div className="text-[11px] text-muted-foreground">{label}</div>
        {value && <div className="text-sm font-medium truncate">{value}</div>}
      </div>
      <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
    </button>
  )
}
